import React from 'react'

import { MasterDataManagement } from '../features/selfservice/master-data-management'

export const MasterDataManagementPage: React.FC = () => {
  return <MasterDataManagement />
}
